import React, { useState } from "react";
import { t } from "i18next";
import { updateAbout } from "../../../api/postCompanyData";
import Modal from "../../../common/components/MessageModal";

const MAX_LENGTH = 1000;

export default function AboutCompany({ handleDescriptionChangeProp, isSubmitted, description }) {
    const [aboutText, setAboutText] = useState(description || "");
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState({ show: false, message: "" });

    const handleChange = (e) => {
        const value = e.target.value;
        if (value.length > MAX_LENGTH) return;
        setAboutText(value);
        if (handleDescriptionChangeProp) {
            handleDescriptionChangeProp({ target: { value } });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await updateAbout({ text: aboutText });
            setModal({ show: true, message: t('dataUpdateSuccess') });
        } catch (error) {
            console.error("Update failed:", error);
            setModal({ show: true, message: t('updateError') });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div>
                <h3 className="text-base font-semibold text-gray-800 mb-5">{t('aboutCompany')}</h3>
                <form className="flex flex-col gap-4 max-w-2xl" onSubmit={handleSubmit}>
                    <div className="relative">
                        <textarea
                            value={aboutText}
                            onChange={handleChange}
                            rows={8}
                            placeholder={t('description')}
                            className={`w-full px-4 py-3 rounded-xl border text-sm text-gray-800 placeholder-gray-400 resize-none focus:outline-none focus:border-[#147F26] transition ${
                                isSubmitted && !aboutText.trim() ? "border-red-400" : "border-gray-200"
                            }`}
                        />
                        <span className="absolute bottom-3 right-3 text-xs text-gray-400">
                            {aboutText.length}/{MAX_LENGTH}
                        </span>
                    </div>
                    {isSubmitted && !aboutText.trim() && (
                        <p className="text-xs text-red-500 -mt-2">{t('required_text')}</p>
                    )}
                    <div>
                        <button
                            type="submit"
                            className="bg-[#147F26] text-white py-2.5 px-6 rounded-xl font-medium hover:bg-[#0f5f1a] disabled:opacity-60 transition"
                            disabled={loading}
                        >
                            {loading ? t('saving') : t('save')}
                        </button>
                    </div>
                </form>
            </div>
            {modal.show && (
                <Modal
                    message={modal.message}
                    onClose={() => setModal({ show: false, message: "" })}
                />
            )}
        </>
    );
}
